import * as React from "react";
import { forwardRef } from "react";
const SvgDownRightArrowIcon = (props, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 512 512", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "m438.211 369.109-138.2 138.205a16 16 0 1 1 -22.627-22.628l110.887-110.886h-303.171a16 16 0 0 1 -16-16v-341.8a16 16 0 0 1 32 0v325.8h287.171l-110.891-110.895a16 16 0 1 1 22.627-22.627l138.2 138.2a16 16 0 0 1 .004 22.631z" }));
const ForwardRef = forwardRef(SvgDownRightArrowIcon);
export default ForwardRef;
